import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== "/") {
      setScrolled(true);
    } else {
      const handleScroll = () => setScrolled(window.scrollY > 50);
      window.addEventListener("scroll", handleScroll);
      handleScroll();
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, [location]);

  // 🔥 scroll-to-top helper
  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  return (
    <header className={`navbar ${scrolled ? "scrolled" : ""}`}>
      {/* ✅ Logo is now a Link. If already on home, just scroll up. */}
      <Link
        to="/"
        className="logo"
        onClick={() => {
          if (location.pathname === "/") scrollToTop();
        }}
      >
        Melodia Music
      </Link>

      {/* Hamburger Icon */}
      <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
        <div className={`bar ${menuOpen ? "open" : ""}`}></div>
        <div className={`bar ${menuOpen ? "open" : ""}`}></div>
        <div className={`bar ${menuOpen ? "open" : ""}`}></div>
      </div>

      {/* Desktop Navigation */}
      <nav className="desktop-menu">
        <ul>
          <li>
            <Link to="/" onClick={scrollToTop}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/booking" onClick={scrollToTop}>
              Lessons
            </Link>
          </li>
          <li>
            <Link to="/audio" onClick={scrollToTop}>
              Audio
            </Link>
          </li>
          <li>
            <Link to="/pricing" onClick={scrollToTop}>
              Pricing
            </Link>
          </li>
          <li>
            <Link to="/shop" onClick={scrollToTop}>
              Shop
            </Link>
          </li>
          <li>
            <Link to="/contact" onClick={scrollToTop}>
              Contact
            </Link>
          </li>
        </ul>
      </nav>

      {/* Mobile Dropdown Menu */}
      {menuOpen && (
        <div className="mobile-menu">
          <Link
            to="/"
            onClick={() => {
              setMenuOpen(false);
              scrollToTop();
            }}
          >
            Home
          </Link>
          <Link
            to="/booking"
            onClick={() => {
              setMenuOpen(false);
              scrollToTop();
            }}
          >
            Lessons
          </Link>
          <Link
            to="/audio"
            onClick={() => {
              setMenuOpen(false);
              scrollToTop();
            }}
          >
            Audio
          </Link>
          <Link
            to="/pricing"
            onClick={() => {
              setMenuOpen(false);
              scrollToTop();
            }}
          >
            Pricing
          </Link>
          <Link
            to="/shop"
            onClick={() => {
              setMenuOpen(false);
              scrollToTop();
            }}
          >
            Shop
          </Link>
          <Link
            to="/contact"
            onClick={() => {
              setMenuOpen(false);
              scrollToTop();
            }}
          >
            Contact
          </Link>
        </div>
      )}
    </header>
  );
};

export default Navbar;
